import ButtonLink from '../components/ui/ButtonLink';

import Footer from '../components/Footer';
import ContentHeader from '../components/ContentHeader';

export default ({
  heading = undefined as any | string,
  logoOnly = true,
  showCTA = false,
  fullWidth = false,
  children,
}) => (
  <>
    <div className="container mx-auto">
      <div className="mt-5 text-center">
        <div className="px-2 sm:px-6">
          <ContentHeader logoOnly={logoOnly} />
          <div className="container px-12 mx-auto mt-8 mb-5 text-xl font-light sm:mt-16 sm:px-14 xl:px-64">
            <h1 className="lg:text-7xl">{heading}</h1>
          </div>
          {showCTA && (
            <div className="mt-14">
              <ButtonLink className="btn btn-blue" href="/roadmaps">
                Let’s Go
              </ButtonLink>
            </div>
          )}
        </div>
      </div>
    </div>
    <div
      className={`${
        fullWidth ? '' : 'container mx-auto flex flex-col items-center justify-start mt-10'
      } text-center`}
    >
      {children}
    </div>
    <div className="pt-8">
      <Footer showHome={false} />
    </div>
  </>
);
